import {createAction} from 'redux-act';

export const GENERATE_REPORT = createAction('reports/GENERATE_REPORT');
export const GENERATE_REPORT_SUCCESS = createAction(
  'reports/GENERATE_REPORT_SUCCESS'
);
export const GET_REPORTS = createAction('reports/GET_REPORTS');
export const GET_REPORTS_SUCCESS = createAction('reports/GET_REPORTS_SUCCESS');
export const GET_REPORT_CUSTOMERS_SUCCESS = createAction(
  'reports/GET_REPORT_CUSTOMERS_SUCCESS'
);
export const GET_REPORT_SALES_SUMMARY_SUCCESS = createAction(
  'reports/GET_REPORT_SALES_SUMMARY_SUCCESS'
);

export const GET_REPORT_BOOK_A_DRIVER_SUCCESS = createAction(
  'reports/GET_REPORT_BOOK_A_DRIVER_SUCCESS'
);

export const EXPORT_REPORTS = createAction('reports/EXPORT_REPORTS');
export const STOP_EXPORT_REPORTS_LOADING = createAction(
  'reports/STOP_EXPORT_REPORTS_LOADING'
);

export const GET_REPORT_CUSTOMERS = createAction(
  'reports/GET_REPORT_CUSTOMERS'
);
export const GET_REPORT_SALES_SUMMARY = createAction(
  'reports/GET_REPORT_SALES_SUMMARY'
);
export const GET_REPORT_PAYOUT_SUMMARY = createAction(
  'reports/GET_REPORT_PAYOUT_SUMMARY'
);
export const GET_REPORT_BOOK_A_DRIVER = createAction(
  'reports/GET_REPORT_BOOK_A_DRIVER'
);
export const GET_REPORT_BYOC = createAction('reports/GET_REPORT_BYOC');

export const STOP_REPORTS_LOADING = createAction(
  'reports/STOP_REPORTS_LOADING'
);

export const SET_REPORTS_DATE_INTERVAL = createAction(
  'reports/SET_REPORTS_DATE_INTERVAL'
);

export const SET_DATEPICKER_INDEX = createAction(
  'reports/SET_DATEPICKER_INDEX'
);

export const SET_REPORT_TYPE = createAction('reports/SET_REPORT_TYPE');

export const CLEAR_REPORT_DATA = createAction('reports/CLEAR_REPORT_DATA');

export const SET_REPORT_LOCATION = createAction('reports/SET_REPORT_LOCATION');

export const REPORTS_PAGINATE = createAction('reports/REPORTS_PAGINATE');

export const SET_REPORT_VISITED_STATISTIC = createAction(
  'reports/SET_REPORT_VISITED_STATISTIC'
);
export const GENERATE_SPECIAL_ORDERS_REPORT = createAction(
  'reports/GENERATE_SPECIAL_ORDERS_REPORT'
);
export const GENERATE_SPECIAL_ORDERS_REPORT_SUCCESS = createAction(
  'reports/GENERATE_SPECIAL_ORDERS_REPORT_SUCCESS'
);

export const SET_TIME_PERIOD = createAction('reports/SET_TIME_PERIOD');

export const SET_SALES_BREAKDOWN_CHANNELS = createAction(
  'reports/SET_SALES_BREAKDOWN_CHANNELS'
);

export const SET_SALES_BREAKDOWN_FULFILLMENTS = createAction(
  'reports/SET_SALES_BREAKDOWN_FULFILLMENTS'
);

export const RECALCULATE_COMMISSION_SAVED = createAction(
  'reports/RECALCULATE_COMMISSION_SAVED'
);

export const SET_SELF_DELIVERY_DATE_FILTER = createAction(
  'reports/SET_SELF_DELIVERY_DATE_FILTER'
);
export const SET_SELF_DELIVERY_INVOICES_PERIOD = createAction(
  'reports/SET_SELF_DELIVERY_INVOICES_PERIOD'
);
export const DOWNLOAD_SELF_DELIVERY_INVOICE_ORDERS = createAction(
  'reports/DOWNLOAD_SELF_DELIVERY_INVOICE_ORDERS'
);
export const DOWNLOAD_SELF_DELIVERY_INVOICE_ORDERS_DONE = createAction(
  'reports/DOWNLOAD_SELF_DELIVERY_INVOICE_ORDERS_DONE'
);
export const OPEN_SELF_DELIVERY_INVOICE = createAction(
  'reports/OPEN_SELF_DELIVERY_INVOICE'
);
export const OPEN_SELF_DELIVERY_INVOICE_DONE = createAction(
  'reports/OPEN_SELF_DELIVERY_INVOICE_DONE'
);
